import { IApiActionResult } from "src/~api/ApiActionResult";
import { fetchGet, fetchPost, getApiActionResult } from "src/~api/ApiHelper";

export interface INLogConfigResult {
    config: string;
    errors: string[];
    isOverride: boolean;
}

export const getNLogConfigAsync = async (route: string): Promise<IApiActionResult<INLogConfigResult>> => {
    return await getApiActionResult(fetchGet(`${route}/get-config`), true);
}

export const validateNLogConfigAsync = async (route: string, config: string): Promise<IApiActionResult<INLogConfigResult>> => {
    return await getApiActionResult(fetchPost(`${route}/validate-config`, { body: JSON.stringify({ config }) }), true);
}

export const applyNLogConfigAsync = async (route: string, config: string): Promise<IApiActionResult<INLogConfigResult>> => {
    return await getApiActionResult(fetchPost(`${route}/apply-config`, { body: JSON.stringify({ config }) }), true);
}

export const resetNLogConfigAsync = async (route: string): Promise<IApiActionResult<INLogConfigResult>> => {
    return await getApiActionResult(fetchPost(`${route}/reset-config`), true);
}
